import React, { useEffect } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";

import * as actions from "../../../store/actions";

import "./index.css";

import SingleInputDate from "../../../components/formElements/datepicker/SingleInputDate";
import SlotsAvailability from "./SlotsAvailability";

const AvailabilitySchedule = ({
  availabilitySchedule,
  setAvailabilitySchedule,
}) => {
  useEffect(() => {
    setAvailabilitySchedule({ scheduledDate: new Date() });
    //eslint-disable-next-line
  }, []);

  return (
    <div>
      <div className="w-100 d-flex">
        <p className="DBSubTitle mb-2">Availability Schedule</p>
      </div>
      <div className="row">
        <div className="col-md-3 mx-auto">
          <SingleInputDate
            value={availabilitySchedule.scheduledDate}
            onChange={date => setAvailabilitySchedule({ scheduledDate: date })}
          />
        </div>
      </div>
      <div className="row">
        <div className="col-md-12">
          <SlotsAvailability />
        </div>
      </div>
    </div>
  );
};

const mapStoreToProps = ({ dashboard }) => ({
  availabilitySchedule: dashboard.availabilitySchedule,
});

const mapDispatchToProps = dispatch => ({
  setAvailabilitySchedule: updatedData =>
    dispatch(actions.setAvailabilitySchedule(updatedData)),
});

export default withRouter(
  connect(mapStoreToProps, mapDispatchToProps)(AvailabilitySchedule)
);
